import * as React from 'react';
import * as styles from "./Admin.css";
import { inject, observer } from 'mobx-react';
import { NavigatorStore } from '../../stores';
import NavigatorService from '../../../../services/NavigatorService';
import { IDraft } from '../../../../interfaces/IDraft';
import { Environment } from '../../../../services/Environment';
import DesignSettingsPanel from '../designSettingsPanel/DesignSettingsPanel';
import TopItemSettingsPanel from '../topItemSettingsPanel/TopItemSettingsPanel';
import ElementGroupSettingsPanel from '../elementGroupSettingsPanel/ElementGroupSettingsPanel';
import ElementSettingsPanel from '../elementSettingsPanel/ElementSettingsPanel';
import { IAPivot } from '../../../pivot/Pivot';
import { IAPopup } from '../../../popup/Popup';
import DateTimeService from '../../../../services/DateTimeService';
import { LocalizationService } from '../../../../services/LocalizationService';
import { ICheckOut } from '../../../../interfaces/ICheckOut';
import UserService from '../../../../services/UserService';
import { IUserRole } from '../../../../interfaces/IUserRole';
import { Helper } from '../../../../Helper';
import { IAButton } from '../../../button/Button';
import AnalyticsPanel from '../analyticsPanel/AnalyticsPanel';
const IC_SPINNER = require("../../../../images/spinner.png");
const defaultNavigator = require('../../configuration.json');

export interface IAdminProps {
  version: string;
  navigatorStore?: NavigatorStore;
}

export interface IAdminState {
  isCheckingInNavigator: boolean;
}

@inject('navigatorStore')
@observer
export class Admin extends React.Component<IAdminProps, IAdminState> {

  private readonly dateTimeService: DateTimeService = new DateTimeService();
  private localizationService: LocalizationService = new LocalizationService();

  constructor(props: IAdminProps) {
    super(props);
    this.state = {
      isCheckingInNavigator: false
    }
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public componentDidMount(): void {
    this.getVersions();
    this.props.navigatorStore.adminPivot = "Content";
    this.props.navigatorStore.getTargetingApplication();
  }

  public componentWillReceiveProps(props: IAdminProps): void {
    if (props.version !== this.props.version) {
      this.getVersions();
    }
  }

  private sortById(array: IDraft[]): any[] {
    return array.sort((l1, l2) => {
      if (l1.configuration.version.id > l2.configuration.version.id) {
        return 1;
      }
      if (l1.configuration.version.id < l2.configuration.version.id) {
        return -1;
      }
      return 0;
    });
  }

  private getVersions(): void {
    this.props.navigatorStore.versions = undefined;
    NavigatorService.getAllNavigators(`${Environment.getEnvironmentForMainAPI(this.props.navigatorStore.environment)}/api/${this.props.navigatorStore.tenant}/navigator/all?instanceName=${this.props.navigatorStore.instance}`, this.props.navigatorStore.token, this.props.navigatorStore.instance).then((versions: IDraft[]) => {
      versions = versions?.filter((version: IDraft) => version.configuration.version.public || version.configuration.design.newVersioning);
      versions = this.sortById(versions);
      this.props.navigatorStore.setVersions(versions);
      if (this.props.navigatorStore.isInEditMode) {
        if (versions.length > 0) {
          if (versions.length > 1 && versions[versions.length - 1].configuration?.design?.newVersioning) {
            this.props.navigatorStore.setNavigator(versions[versions.length - 1].configuration);
          } else {
            // Create new draft
            this.props.navigatorStore.setNavigator(versions[0].configuration);
            this.props.navigatorStore.navigator.version.public = false;
            Helper.setLocalStorage(`navigator-${this.props.navigatorStore.instanceId}`, JSON.stringify(this.props.navigatorStore.navigator));
            NavigatorService.createNavigator(`${Environment.getEnvironmentForMainAPI(this.props.navigatorStore.environment)}/api/${this.props.navigatorStore.tenant}/navigator?instanceName=${this.props.navigatorStore.instance}`, this.props.navigatorStore.instanceId, this.props.navigatorStore.token, this.props.navigatorStore.instance).then(async (versionId: number) => {
              this.props.navigatorStore.navigator.version.id = versionId;
              this.props.navigatorStore.navigator.design.newVersioning = true;
              this.props.navigatorStore.navigator.version.public = false;
              this.props.navigatorStore.setNavigator(this.props.navigatorStore.navigator);
              this.props.navigatorStore.checkForChanges();
              await NavigatorService.updateNavigator(`${Environment.getEnvironmentForMainAPI(this.props.navigatorStore.environment)}/api/${this.props.navigatorStore.tenant}/navigator?instanceName=${this.props.navigatorStore.instance}`, this.props.navigatorStore.instanceId, this.props.navigatorStore.token, this.props.navigatorStore.instance);
              this.getVersions();
            });
          }
          if (versions.length > 1 && !this.props.navigatorStore.navigator.version.public) {
            this.isCheckedOut();
          }
          if (localStorage.getItem(`navigator-modified-${this.props.navigatorStore.instanceId}`) != undefined && localStorage.getItem(`navigator-${this.props.navigatorStore.instanceId}`) != undefined && localStorage.getItem(`navigator-modified-${this.props.navigatorStore.instanceId}`) != localStorage.getItem(`navigator-${this.props.navigatorStore.instanceId}`)) {
            this.props.navigatorStore.showForgotToSavePopup = true;
          }
        } else {
          this.props.navigatorStore.setNavigator(defaultNavigator);
          NavigatorService.createNavigator(
            `${Environment.getEnvironmentForMainAPI(this.props.navigatorStore.environment)}/api/${this.props.navigatorStore.tenant
            }/navigator?instanceName=${this.props.navigatorStore.instance}`,
            this.props.navigatorStore.instanceId,
            this.props.navigatorStore.token,
            this.props.navigatorStore.instance,
          ).then(() => {
            this.getVersions();
          });
        }
      }
    });
  }

  private isCheckedOut(): void {
    UserService.getUserRole(
      Environment.getEnvironmentForMainAPI(this.props.navigatorStore.environment),
      this.props.navigatorStore.tenant,
      this.props.navigatorStore.instanceId,
      this.props.navigatorStore.token,
      'IntraActive-NavigatorAdmin',
    ).then((userRole: IUserRole) => {
      this.props.navigatorStore.setUserRole(userRole);
      Helper.setLocalStorage('userRole', JSON.stringify(userRole));
      NavigatorService.isCheckedOut(
        `${Environment.getEnvironmentForMainAPI(this.props.navigatorStore.environment)}/api/${this.props.navigatorStore.tenant}/navigator/${this.props.navigatorStore.navigator.version.id
        }/status?instanceName=${this.props.navigatorStore.instance}`,
        this.props.navigatorStore.token,
        this.props.navigatorStore.instance,
      ).then((checkOut: ICheckOut) => {
        console.log(this.props.navigatorStore.user.userPrincipalName);
        console.warn(checkOut);
        if (
          checkOut == undefined ||
          !checkOut.checkedOut ||
          (checkOut.author &&
            this.props.navigatorStore.user &&
            checkOut.author.email &&
            this.props.navigatorStore.user.userPrincipalName &&
            checkOut.author.email.toLowerCase() == this.props.navigatorStore.user.userPrincipalName.toLowerCase())
        ) {
          this.props.navigatorStore.checkOut = undefined;
          this.props.navigatorStore.checkedOut = false;
          if (checkOut.author &&
            this.props.navigatorStore.user &&
            checkOut.author.email.toLowerCase() == this.props.navigatorStore.user.userPrincipalName.toLowerCase()) {
            this.props.navigatorStore.hasChanged = Helper.getRandomStringKey();
          }
        } else {
          this.props.navigatorStore.checkOut = checkOut;
          this.props.navigatorStore.checkedOut = true;
          console.log(`${checkOut.author.name} has checked out the navigator!`);
        }
      });
    });
  }

  private checkIn(): void {
    NavigatorService.checkOut(
      `${Environment.getEnvironmentForMainAPI(this.props.navigatorStore.environment)}/api/${this.props.navigatorStore.tenant}/navigator/${this.props.navigatorStore.navigator.version.id
      }/status?instanceName=${this.props.navigatorStore.instance}&checkedOut=false`,
      this.props.navigatorStore.token,
      this.props.navigatorStore.instance,
    ).then((status: any) => {
      console.log(status);
    });
  }

  render() {
    const draftHasChanges = this.props.navigatorStore.versions && this.props.navigatorStore.versions.length > 1 &&
      (JSON.stringify(this.props.navigatorStore.versions[0].configuration.design.elements) !== JSON.stringify(this.props.navigatorStore.versions[1].configuration.design.elements) ||
        JSON.stringify(this.props.navigatorStore.versions[0].configuration.design.elementGroups) !== JSON.stringify(this.props.navigatorStore.versions[1].configuration.design.elementGroups) ||
        JSON.stringify(this.props.navigatorStore.versions[0].configuration.design.menuBar) !== JSON.stringify(this.props.navigatorStore.versions[1].configuration.design.menuBar) ||
        JSON.stringify(this.props.navigatorStore.versions[0].configuration.design.topItems) !== JSON.stringify(this.props.navigatorStore.versions[1].configuration.design.topItems) ||
        JSON.stringify(this.props.navigatorStore.versions[0].configuration.megamenu) !== JSON.stringify(this.props.navigatorStore.versions[1].configuration.megamenu) ||
        JSON.stringify(this.props.navigatorStore.versions[0].configuration.smartmenu) !== JSON.stringify(this.props.navigatorStore.versions[1].configuration.smartmenu));
    const showPublishButton: boolean = (draftHasChanges || this.props.navigatorStore.hasChanged != undefined) && (this.props.navigatorStore.navigator != undefined && this.props.navigatorStore.hasChanged != undefined || this.props.navigatorStore.navigator != undefined && !this.props.navigatorStore.navigator.version.public);
    if (draftHasChanges) {
      console.log(JSON.stringify(this.props.navigatorStore.versions[0].configuration.megamenu));
      console.log(JSON.stringify(this.props.navigatorStore.versions[1].configuration.megamenu));
    }
    return (
      <div
        className={styles.adminBar}
        style={{
          display: this.props.navigatorStore.isInEditMode ? "block" : "none"
        }}
      >
        {this.props.navigatorStore.navigator != undefined &&
          <div>
            <div>
              <IAPivot
                highlightColor={this.props.navigatorStore.adminColor}
                items={[
                  {
                    key: "Content",
                    text: this.localizationService.strings.Navigator_Settings_Content
                  },
                  {
                    key: "Design settings",
                    text: this.localizationService.strings.Navigator_Design_DesignSettings,
                    disabled: this.props.navigatorStore.checkedOut
                  },
                  {
                    key: "Analytics",
                    text: this.localizationService.strings.Navigator_Analytics_Title
                  }
                ]}
                selectedKey={this.props.navigatorStore.adminPivot}
                select={(selectedPivot: string) => {
                  this.props.navigatorStore.adminPivot = selectedPivot;
                  switch (selectedPivot) {
                    case "General settings":
                      if (this.props.navigatorStore.isShowingDesignSettings) {
                        this.props.navigatorStore.toggleDesignSettings();
                      }
                      if (this.props.navigatorStore.isShowingAnalytics) {
                        this.props.navigatorStore.toggleAnalytics();
                      }
                      break;
                    case "Content":
                      if (this.props.navigatorStore.isShowingDesignSettings) {
                        this.props.navigatorStore.toggleDesignSettings();
                      }
                      if (this.props.navigatorStore.isShowingAnalytics) {
                        this.props.navigatorStore.toggleAnalytics();
                      }
                      break;
                    case "Design settings":
                      this.props.navigatorStore.toggleDesignSettings();
                      break;
                    case "Analytics":
                      this.props.navigatorStore.toggleAnalytics();
                      if (!this.props.navigatorStore.navigatorClicks) {
                        this.props.navigatorStore.getNavigatorClicks(this.props.navigatorStore.fromDate, this.props.navigatorStore.toDate);
                      }
                      break;
                  }
                }}
                style={{
                  width: "auto",
                  float: "left",
                  marginLeft: 20
                }}
              />
              {!this.props.navigatorStore.checkedOut &&
                <button
                  className={styles.saveButton}
                  disabled={!showPublishButton}
                  style={{
                    opacity: showPublishButton ? 1 : 0.5,
                    backgroundColor: this.props.navigatorStore.adminColor,
                    padding: this.props.navigatorStore.isPublishing ? "0 7px 0 7px" : "0 15px",
                    marginRight: 20
                  }}
                  onClick={() => {
                    this.props.navigatorStore.isPublishing = true;
                    this.props.navigatorStore.navigator.version.public = true;
                    this.props.navigatorStore.navigator.design.newVersioning = true;
                    this.props.navigatorStore.setNavigator(this.props.navigatorStore.navigator);
                    NavigatorService.updateNavigator(`${Environment.getEnvironmentForMainAPI(this.props.navigatorStore.environment)}/api/${this.props.navigatorStore.tenant}/navigator?instanceName=${this.props.navigatorStore.instance}`, this.props.navigatorStore.instanceId, this.props.navigatorStore.token, this.props.navigatorStore.instance).then((id: number) => {
                      this.props.navigatorStore.isPublishing = false;
                      this.props.navigatorStore.checkForChanges();
                      if (id) {
                        localStorage.removeItem(`navigator-modified-${this.props.navigatorStore.instanceId}`);
                        if (this.props.navigatorStore.versions.length > 1 && this.props.navigatorStore.navigator?.version?.id !== 1) {
                          this.props.navigatorStore.versions.forEach((version, index) => {
                            if (version?.configuration?.version?.id !== id && version?.configuration?.version?.id !== 1) {
                              NavigatorService.deleteNavigator(`${Environment.getEnvironmentForMainAPI(this.props.navigatorStore.environment)}/api/${this.props.navigatorStore.tenant}/navigator/${version?.configuration?.version?.id}?instanceName=${this.props.navigatorStore.instance}`, this.props.navigatorStore.instanceId, this.props.navigatorStore.token, this.props.navigatorStore.instance).then(() => {
                                if (index === this.props.navigatorStore.versions.length - 1) {
                                  this.getVersions();
                                }
                              });
                            }
                          })
                        }
                      } else {
                        alert(this.localizationService.strings.Navigator_Admin_PublishingFailed)
                      }
                    });
                  }}
                >
                  {this.props.navigatorStore.isPublishing ?
                    <div
                      className={styles.navigationSpinner}
                      style={{ backgroundImage: "url(" + IC_SPINNER + ")" }}
                    />
                    :
                    this.localizationService.strings.Navigator_Admin_SaveAndPublishButton
                  }
                </button>
              }
              {!this.props.navigatorStore.checkedOut &&
                <button
                  className={styles.saveButton}
                  disabled={this.props.navigatorStore.hasChanged == undefined || this.props.navigatorStore.isPublishing}
                  style={{
                    opacity: this.props.navigatorStore.hasChanged != undefined ? 1 : 0.5,
                    backgroundColor: this.props.navigatorStore.adminColor,
                    padding: "0 10px 0 10px"
                  }}
                  onClick={() => {
                    if (this.props.navigatorStore.navigator.version.public || this.props.navigatorStore.navigator.version.id == undefined) {
                      // Create new draft
                      this.props.navigatorStore.navigator.version.public = false;
                      Helper.setLocalStorage(`navigator-${this.props.navigatorStore.instanceId}`, JSON.stringify(this.props.navigatorStore.navigator));
                      localStorage.removeItem(`navigator-modified-${this.props.navigatorStore.instanceId}`);
                      NavigatorService.createNavigator(`${Environment.getEnvironmentForMainAPI(this.props.navigatorStore.environment)}/api/${this.props.navigatorStore.tenant}/navigator?instanceName=${this.props.navigatorStore.instance}`, this.props.navigatorStore.instanceId, this.props.navigatorStore.token, this.props.navigatorStore.instance).then(async (versionId: number) => {
                        this.props.navigatorStore.navigator.version.id = versionId;
                        this.props.navigatorStore.navigator.design.newVersioning = true;
                        this.props.navigatorStore.setNavigator(this.props.navigatorStore.navigator);
                        this.props.navigatorStore.checkForChanges();
                        await NavigatorService.updateNavigator(`${Environment.getEnvironmentForMainAPI(this.props.navigatorStore.environment)}/api/${this.props.navigatorStore.tenant}/navigator?instanceName=${this.props.navigatorStore.instance}`, this.props.navigatorStore.instanceId, this.props.navigatorStore.token, this.props.navigatorStore.instance);
                        this.getVersions();
                      });
                    } else {
                      // Update current draft
                      this.props.navigatorStore.isSaving = true;
                      Helper.setLocalStorage(`navigator-${this.props.navigatorStore.instanceId}`, JSON.stringify(this.props.navigatorStore.navigator));
                      localStorage.removeItem(`navigator-modified-${this.props.navigatorStore.instanceId}`);
                      NavigatorService.updateNavigator(`${Environment.getEnvironmentForMainAPI(this.props.navigatorStore.environment)}/api/${this.props.navigatorStore.tenant}/navigator?instanceName=${this.props.navigatorStore.instance}`, this.props.navigatorStore.instanceId, this.props.navigatorStore.token, this.props.navigatorStore.instance)
                        .then((versionId: number) => {
                          this.props.navigatorStore.navigator.version.id = versionId;
                          this.props.navigatorStore.isSaving = false;
                          this.getVersions();
                        });
                    }
                  }}
                >
                  {this.props.navigatorStore.isSaving ? <div className={styles.navigationSpinner} style={{ backgroundImage: "url(" + IC_SPINNER + ")" }} /> : this.localizationService.strings.Navigator_Admin_SaveButton}
                </button>
              }
              {!this.props.navigatorStore.checkedOut &&
                <button
                  className={styles.saveButton}
                  disabled={this.props.navigatorStore.hasChanged == undefined}
                  style={{
                    opacity: this.props.navigatorStore.hasChanged != undefined ? 1 : 0.5,
                    backgroundColor: "gray",
                    color: "white"
                  }}
                  onClick={() => {
                    localStorage.removeItem(`navigator-modified-${this.props.navigatorStore.instanceId}`);
                    this.props.navigatorStore.cancelEdit();
                    this.checkIn();
                  }}
                >
                  {this.localizationService.strings.Navigator_Admin_CancelButton}
                </button>
              }
              {this.props.navigatorStore.getTargetedPreviewComponentIfEnabled().length > 0 &&
                <button
                  className={styles.saveButton}
                  style={{
                    backgroundColor: "transparent",
                    color: this.props.navigatorStore.adminColor,
                    border: `1px solid ${this.props.navigatorStore.adminColor}`
                  }}
                  onClick={() => {
                    this.props.navigatorStore.isShowingMegamenu = false;
                    this.props.navigatorStore.selectTopMenuItem(undefined);
                    this.props.navigatorStore.getTopItems();
                    this.props.navigatorStore.showTargetPreviewPopup = true;
                  }}
                >
                  {this.props.navigatorStore.targetedPreviewIds?.length === 0 ? this.localizationService.strings.Navigator_Admin_TargetPreview : this.localizationService.strings.Navigator_Admin_ChangePreviewTarget}
                </button>
              }
              {!this.props.navigatorStore.checkedOut && draftHasChanges &&
                <button
                  className={styles.saveButton}
                  style={{
                    backgroundColor: "red",
                    color: "white"
                  }}
                  onClick={() => {
                    this.props.navigatorStore.showDeleteDraftPopup = true;
                    localStorage.removeItem(`navigator-modified-${this.props.navigatorStore.instanceId}`);
                  }}
                >
                  {this.localizationService.strings.Navigator_Admin_DeleteDraftButton}
                </button>
              }
              {this.props.navigatorStore.hasChanged != undefined &&
                <div className={styles.checkOutText}>{this.localizationService.strings.Navigator_Admin_CheckedOutToYou}</div>
              }
              {this.props.navigatorStore.checkedOut && this.props.navigatorStore.checkOut &&
                <div className={styles.checkOutBox}>
                  <IAButton
                    label={this.localizationService.strings.Navigator_Admin_CheckedOutOverrideDeleteChanges}
                    buttonColor={this.props.navigatorStore.highlightColor}
                    showSpinner={this.state.isCheckingInNavigator}
                    onClick={() => {
                      this.setState({ isCheckingInNavigator: true });
                      NavigatorService.checkOut(
                        `${Environment.getEnvironmentForMainAPI(this.props.navigatorStore.environment)}/api/${this.props.navigatorStore.tenant}/navigator/${this.props.navigatorStore.navigator.version.id
                        }/status?instanceName=${this.props.navigatorStore.instance}&checkedOut=true`,
                        this.props.navigatorStore.token,
                        this.props.navigatorStore.instance,
                      ).then((status: any) => {
                        if (status == 200) {
                          console.log('You have checked out the navigator!');
                        } else {
                          console.log('Error checking out the navigator: ' + status);
                        }
                        this.setState({ isCheckingInNavigator: false });
                        this.getVersions();
                      });
                    }}
                    style={{
                      float: "right",
                      marginTop: 10
                    }}
                  />
                  <div className={styles.checkOutText}>{`${this.props.navigatorStore.checkOut.author.name} ${this.localizationService.strings.Navigator_Admin_CheckOutPopupPartOne} ${this.dateTimeService.ConvertToDDMMYYYYHHMM(this.props.navigatorStore.checkOut.date)}`}</div>
                </div>
              }
            </div>
          </div>
        }
        {this.props.navigatorStore.navigator != undefined &&
          <DesignSettingsPanel />
        }
        {this.props.navigatorStore.navigator != undefined &&
          <TopItemSettingsPanel />
        }
        {this.props.navigatorStore.navigator != undefined &&
          <ElementGroupSettingsPanel />
        }
        {this.props.navigatorStore.navigator != undefined &&
          <ElementSettingsPanel />
        }
        {this.props.navigatorStore.navigator != undefined &&
          <AnalyticsPanel />
        }
        {this.props.navigatorStore.showDeleteDraftPopup &&
          <IAPopup
            headline={this.localizationService.strings.Navigator_Admin_DeleteDraftButton}
            content={
              <div>
                <div
                  style={{
                    float: "left",
                    fontSize: 14
                  }}
                >
                  <IAButton
                    label={this.localizationService.strings.Navigator_Admin_DeleteDraftButton}
                    buttonColor={"red"}
                    disbaled={this.props.navigatorStore.isDeletingDraft}
                    showSpinner={false}
                    onClick={() => {
                      this.props.navigatorStore.isShowingTopItemSettings = false;
                      this.props.navigatorStore.isShowingElementGroupSettings = false;
                      this.props.navigatorStore.isShowingElementSettings = false;
                      this.props.navigatorStore.isShowingDesignSettings = false;
                      this.props.navigatorStore.isShowingAnalytics = false;
                      this.props.navigatorStore.isDeletingDraft = true;
                      NavigatorService.deleteNavigator(`${Environment.getEnvironmentForMainAPI(this.props.navigatorStore.environment)}/api/${this.props.navigatorStore.tenant}/navigator/${this.props.navigatorStore.navigator.version.id}?instanceName=${this.props.navigatorStore.instance}`, this.props.navigatorStore.instanceId, this.props.navigatorStore.token, this.props.navigatorStore.instance).then(() => {
                        this.props.navigatorStore.showDeleteDraftPopup = false;
                        this.props.navigatorStore.isDeletingDraft = false;
                        this.getVersions();
                      });
                    }}
                    style={{
                      marginTop: 20,
                      float: "left",
                      marginRight: 10
                    }}
                  />
                  <IAButton
                    label={this.localizationService.strings.Navigator_Admin_CancelButton}
                    buttonColor={"#eeeeee"}
                    showSpinner={false}
                    onClick={() => {
                      this.props.navigatorStore.showDeleteDraftPopup = false;
                    }}
                    style={{
                      marginTop: 20,
                      float: "left",
                      marginRight: 10
                    }}
                  />
                </div>
                <div
                  style={{
                    clear: "both",
                    float: "left"
                  }}
                >
                </div>
              </div>
            }
          />
        }
        {this.props.navigatorStore.showForgotToSavePopup &&
          <IAPopup
            headline={this.localizationService.strings.Navigator_Admin_ForgotToSave}
            content={
              <div>
                <div
                  style={{
                    float: "left"
                  }}
                >
                  {this.localizationService.strings.Navigator_Admin_ForgotToSaveMessage}
                </div>
                <div
                  style={{
                    clear: "both",
                    float: "left"
                  }}
                >
                  <IAButton
                    label={this.localizationService.strings.Navigator_Admin_ForgotToSaveButtonSave}
                    buttonColor={this.props.navigatorStore.highlightColor}
                    onClick={() => {
                      this.props.navigatorStore.navigator = JSON.parse(localStorage.getItem(`navigator-modified-${this.props.navigatorStore.instanceId}`));
                      this.props.navigatorStore.showForgotToSavePopup = false;
                      localStorage.removeItem(`navigator-modified-${this.props.navigatorStore.instanceId}`)
                    }}
                    style={{
                      marginTop: 20,
                      float: "left"
                    }}
                  />
                  <IAButton
                    label={this.localizationService.strings.Navigator_Admin_ForgotToSaveButtonCancel}
                    buttonColor={"#999999"}
                    onClick={() => {
                      this.props.navigatorStore.showForgotToSavePopup = false;
                      localStorage.removeItem(`navigator-modified-${this.props.navigatorStore.instanceId}`);
                    }}
                    style={{
                      marginTop: 20,
                      marginLeft: 10,
                      float: "left"
                    }}
                  />
                </div>
              </div>
            }
            close={() => {
              this.props.navigatorStore.showForgotToSavePopup = false;
              localStorage.removeItem(`navigator-modified-${this.props.navigatorStore.instanceId}`);
            }}
          />
        }
      </div>
    )
  }


}